<nb-card style="min-width: 520px; max-width: 720px">
  <nb-card-header>
    <strong>{{ (isEditMode ? 'DEV_CLIENTS.FORM.EDIT_TITLE' : 'DEV_CLIENTS.FORM.CREATE_TITLE') | translate }}</strong>
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="clientForm">
      <div class="row">
        <div class="col-12 mb-3">
          <label class="form-label">{{ 'DEV_CLIENTS.FORM.NAME' | translate }} <span class="text-danger">*</span></label>
          <input nbInput fullWidth class="form-control" [placeholder]="'DEV_CLIENTS.FORM.NAME_PLACEHOLDER' | translate" formControlName="name" />
        </div>

        <div class="col-12 mb-3">
          <label class="form-label">{{ 'DEV_CLIENTS.FORM.DESCRIPTION' | translate }}</label>
          <textarea
            nbInput
            fullWidth
            class="form-control"
            [placeholder]="'DEV_CLIENTS.FORM.DESCRIPTION_PLACEHOLDER' | translate"
            formControlName="description"
            rows="2"
          ></textarea>
        </div>

        <div class="col-12 mb-3" *ngIf="canUseChainMode">
          <label class="form-label d-block">{{ 'DEV_CLIENTS.FORM.ACCESS_MODE' | translate }}</label>
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-sm"
              [class.btn-primary]="accessMode === 'stores'"
              [class.btn-outline-primary]="accessMode !== 'stores'"
              (click)="setAccessMode('stores')"
            >
              {{ 'DEV_CLIENTS.FORM.MODE_STORES' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-sm"
              [class.btn-primary]="accessMode === 'chain'"
              [class.btn-outline-primary]="accessMode !== 'chain'"
              (click)="setAccessMode('chain')"
            >
              {{ 'DEV_CLIENTS.FORM.MODE_CHAIN' | translate }}
            </button>
          </div>
        </div>

        <div class="col-12 mb-3" *ngIf="accessMode === 'stores'">
          <label class="form-label">{{ 'DEV_CLIENTS.FORM.STORES' | translate }} <span class="text-danger">*</span></label>
          <ng-select
            [items]="stores"
            bindLabel="storeName"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            [placeholder]="'DEV_CLIENTS.FORM.STORES_PLACEHOLDER' | translate"
            [(ngModel)]="selectedStoreIds"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onStoreIdsChange($event)"
          >
            <ng-template ng-label-tmp let-item="item">{{ storeDisplayName(item) }}</ng-template>
            <ng-template ng-option-tmp let-item="item">{{ storeDisplayName(item) }}</ng-template>
          </ng-select>
        </div>

        <div class="col-12 mb-3" *ngIf="accessMode === 'chain' && canUseChainMode">
          <label class="form-label">{{ 'DEV_CLIENTS.FORM.CHAIN' | translate }} <span class="text-danger">*</span></label>
          <ng-select formControlName="chainId" [placeholder]="'DEV_CLIENTS.FORM.CHAIN_PLACEHOLDER' | translate">
            <ng-option *ngFor="let chain of chains" [value]="chain._id">{{ chainDisplayName(chain) }}</ng-option>
          </ng-select>
        </div>

        <div class="col-12">
          <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
            <label class="form-label mb-0">{{ 'DEV_CLIENTS.FORM.SCOPES' | translate }} <span class="text-danger">*</span></label>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="applyFonixPreset()">
              {{ 'DEV_CLIENTS.FORM.FONIX_PRESET' | translate }}
            </button>
          </div>
          <div class="scopes-grid">
            <div *ngFor="let scope of availableScopes" class="scope-item">
              <nb-checkbox [checked]="isScopeSelected(scope)" (checkedChange)="toggleScope(scope)">
                <span [class.text-warning]="scope === customersPiiScope">{{ scopeLabelKey(scope) | translate }}</span>
                <small class="text-muted d-block">{{ scope }}</small>
              </nb-checkbox>
              <div *ngIf="scope === customersPiiScope && isScopeSelected(scope)" class="pii-warning mt-1">
                <nb-icon icon="alert-triangle-outline"></nb-icon>
                {{ 'DEV_CLIENTS.FORM.PII_WARNING' | translate }}
              </div>
            </div>
          </div>
          <small *ngIf="availableScopes.length === 0" class="text-muted">{{ 'DEV_CLIENTS.FORM.SCOPES_LOADING' | translate }}</small>
        </div>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary px-4" (click)="onCancel()">{{ 'DEV_CLIENTS.FORM.CANCEL' | translate }}</button>
      <button type="button" class="btn btn-primary px-4" (click)="onSubmit()">
        {{ (isEditMode ? 'DEV_CLIENTS.FORM.SAVE' : 'DEV_CLIENTS.FORM.CREATE') | translate }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">{{ 'DEV_CLIENTS.FORM.SAVING' | translate }}</p>
</ngx-spinner>
